<template>
  <div id="app">
    <!-- 只有当前路由不是登录页时才显示菜单 -->
    <MenuBar 
      v-if="$route.path !== '/login'"
      :class="{ 
        'text-white': $route.path === '/', 
        'mistake': $route.path !== '/' 
      }"/>
    <router-view />
    <!-- 悬浮按钮组件 -->
    <FloatingActions v-if="$route.path !== '/login'" :SpgData="SpgData"/>
    <!-- 只有当前路由不是登录页时才显示页脚 -->
    <FooterBar v-if="$route.path !== '/login'" :SpgData="SpgData" :QRcode="SpgData.QRcode" :adminLogin="SpgData.adminLogin"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data(){
    return {
      SpgData:{},
      // PosterInfo: { 活动海报弹窗
      //   start: true,
      //   dynamicId: "688aea9d9bf5cd01d7ae8f8c0",
      //   posterImage: "http://www.3pg.cn/static/%E6%B5%B7%E6%8A%A503.1f799b3f.jpg"
      // }
    }
  },
  created() {
    this.getSPGData()
  },
  mounted() {
    // 确保 DOM 渲染完成后初始化 Wow
    this.$nextTick(() => {
      this.$wow.init()
    })
    // 初始化时，将 html 的 lang 设置为当前 i18n 语言
    document.documentElement.lang = this.$i18n.locale;

    // 监听语言切换事件，实时同步
    this.$i18n.$on('languageChanged', (newLang) => {
      document.documentElement.lang = newLang; // newLang 是切换后的语言（如 'en'）
    });
  },
  methods:{
    // 请求获取数据信息
    getSPGData() {
      const query = new this.$AV.Query("SPG");
      query.get("688aea9d9bf5cd01d7ae8f8c")
      .then((SpgData) => {
        this.SpgData = JSON.parse(SpgData._hashedJSON.SpgData)
        // console.log(this.SpgData)
      })
      .catch((err) => {
        console.error(err.message)
      });
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* padding-top: 80px; */
  box-sizing:border-box;
}
/* 在全局样式中定义首页导航栏的白色字体样式 */
.MenuBar.text-white .nav a {
  color: white;
}
.wow {
  visibility: hidden;
}
/* 如果MenuBar内部有子元素需要单独设置 */
.text-white .nav a,
.text-white .menu-item {
  color: white;
}

</style>
